import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import DefaultContext from "./auth/Context";
class Progress extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={
      running:false,
      title:"",
      load:0
    }
    this.timer ="";
    this.running = this.running.bind(this);
  }
  running(status,callback,title){
    if(this.timer && (title!==this.timer || !status)){
      console.timeEnd(this.timer);
      this.timer ="";
    }
    if(status && title){
      this.timer = title + "::" + (new Date().getTime());
      console.time(this.timer)
    } 
    this.setState({running:status,title,load:this.state.load+1},callback);
  }
  render(){
    if(!this.state.running) return null
    if(this.props.render){
      return this.props.render();
    }
    return (
      <div style={{top:0,bottom:0,left:0,right:0,zIndex:999999999,position:"fixed",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",...(this.props.style||{})}}>
        <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",padding:10,borderRadius:5,backgroundColor:"transparent"}}>
          <CircularProgress style={{color: (this.context.config.primaryColor || "blue"),width:48,height:48}}/>
        </div>
      </div>
    )
  }
}
Progress.contextType = DefaultContext;
export default Progress;